
import DateTimePicker from 'components/GenericComponent/DateTimePicker';
import NumberField from 'components/GenericComponent/NumberField';
import NumberInput from 'components/GenericComponent/NumberInput';
import { PopoversBootrap } from 'components/GenericComponent/PopoversBootrap';
import React, { useState, useRef, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { Controller, useForm } from 'react-hook-form';
import { formatNumber } from 'utils/currencyFormat';
import { convertToNumber } from 'utils/numberExtension';
function ChiTietSoTienDaTra(props) {
    let { show, onHide, data } = props;

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onHide(); // Gọi hàm đóng popup
            }
        };

        // Thêm sự kiện lắng nghe khi component được mount
        document.addEventListener('keydown', handleEscape);

        // Dọn dẹp sự kiện khi component unmount
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onHide]);
    return (
        <Modal
            show={show}
            size="modal-dialog modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
             <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
              <img src="/app-assets/images/icon-donglai.png" alt="" />
          </span>{" "}
         Chi tiết tiền đã trả
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
            <Modal.Body className="">
                <div className="from-tinhtrangno">
                    <form className="form tat-toan form-horizontal">
                        <div className="form-body">
                            <div className="col-md-12">
                                <div className='row'>
                                    <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                        <label style={{ minWidth: "150px" }}>
                                            Tiền gốc:
                                        </label>
                                        <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_ValueGoc)}</span>
                                    </div>
                                    <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                        <label style={{ minWidth: "150px" }}>
                                            Tiền lãi:
                                        </label>
                                        <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_ValueLai)}</span>
                                    </div>
                                    <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                        <label style={{ minWidth: "150px" }}>
                                            Phí khác:
                                        </label>
                                        <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_OtherFee)}</span>
                                    </div>
                                    {data.TC_PhiKho > 0 && (
                                        <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                            <label style={{ minWidth: "150px" }}>
                                                Phí kho:
                                            </label>
                                            <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_PhiKho)}</span>
                                        </div>
                                    )}
                                    <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                        <label style={{ minWidth: "150px" }}>
                                            Phí hàng kỳ:
                                        </label>
                                        <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_OtheFeeHangKy)}</span>
                                    </div>
                                    {(data.TC_Amercement) > 0 && (
                                        <>
                                            <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                                <label style={{ minWidth: "150px" }}>
                                                    Phí phạt:
                                                </label>
                                                <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_Amercement)}</span>
                                            </div>
                                        </>
                                    )}
                                    {(data.TC_PhiPhatDongLai) > 0 && (
                                        <>
                                            <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                                <label style={{ minWidth: "150px" }}>
                                                    Phí phạt đóng lãi:
                                                </label>
                                                <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_PhiPhatDongLai)}</span>
                                            </div>
                                        </>
                                    )}
                                    {data.TC_PhiHoaHongTraGop > 0 && (
                                        <>
                                            <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                                <label style={{ minWidth: "150px" }}>
                                                    Phí hoa hồng trả góp:
                                                </label>
                                                <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_PhiHoaHongTraGop)}</span>
                                            </div>
                                        </>
                                    )}
                                     {data.TC_PhiPhatTatToan > 0 && (
                                        <>
                                            <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                                <label style={{ minWidth: "150px" }}>
                                                    Phí phạt tất toán:
                                                </label>
                                                <span style={{ color: "#FF5170" }}>{formatNumber(data.TC_PhiPhatTatToan)}</span>
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onHide}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>
                    Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
}
export default ChiTietSoTienDaTra;
